<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="2a">
          <div v-for="line in copy.left" v-html="line" :key="line"></div>
        </div>
        <div ref="textB" data-scene="2b">
          <div v-for="line in copy.right" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureC" data-scene="2c">
          <Img :src="require('@/assets/scene2/spread2_c.png')" filename="spread2_c" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="2b">
          <Img :src="require('@/assets/scene2/spread2_b.png')" filename="spread2_b" />
        </figure>

        <figure class="o-section__figure anim-scene-2" ref="figureA2" data-scene="2a2">
          <Img :src="require('@/assets/scene2/spread2_a2.png')" filename="spread2_a2" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="2a">
          <Img :src="require('@/assets/scene2/spread2_a.png')" filename="spread2_a" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene2',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene2', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2],
        translateX: ['0', '-40px'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureA2.querySelector('div'),
        rotate: ['0', '-3deg'],
        duration: 200,
        delay: 800,
        loop: true,
        direction: 'alternate',
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['30px', '0'],
        opacity: [0, 1],
        duration: 2670,
        delay: 330,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureC,
          translateX: ['-60px', '0'],
          opacity: [0, 1],
          duration: 2340,
          delay: 660,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureC,
          translateX: ['-60px', '0'],
          opacity: [0, 1],
          filter: ['blur(25px)', 'blur(0px)'],
          duration: 2340,
          delay: 660,
          easing: this.options.easing
        })
      }
    }
  },

  components: {
    Img
  }
}
</script>
